//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibTitle',
  props: {
    path: {
      type: String,
      default: '',
      required: false
    },
    showBackButton: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '',
      required: false
    },
    text: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    backColor: function backColor() {
      return this.theme.greyColor;
    }
  }
};